module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModelListPage', {
    attrs: {
      "lower-app-name": "systemsettings",
      "lower-model-name": "systemsettings",
      "version": "1",
      "title": "系统配置列表"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b5a808"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/SystemSettingsList.vue
// module id = 365
// module chunks = 1